import { OwaFluidOneDriveService, monitorProgress } from '../../services/OwaFluidOneDriveService';
import { getDriverDetailsForFluidItem } from './getDriverDetailsForFluidItem';
import {
    encodeOdspFluidDataStoreLocator,
    OdspFluidDataStoreLocator,
} from '@fluidframework/odsp-driver';

const GRAPH_RESOURCE_URL = 'https://graph.microsoft.com';
const GRAPH_COPY_DRIVE_ITEM_BASE = `${GRAPH_RESOURCE_URL}/v1.0/me/drive/items`;

export async function copyFluidComponent(shareLink: string, newFileName: string): Promise<string> {
    const driverDetails = getDriverDetailsForFluidItem(shareLink);
    const { driveId, fileId } = driverDetails;

    const requestUrl = `${GRAPH_COPY_DRIVE_ITEM_BASE}/${fileId}/copy`;
    let copyResultShareLink;

    const requestBody = {
        parentReference: {
            driveId,
        },
        name: newFileName,
    };

    const requestInit: RequestInit = {
        method: 'POST',
        body: JSON.stringify(requestBody),
    };

    const response = await OwaFluidOneDriveService(requestUrl, requestInit);
    const monitorUrl = response?.headers?.get('Location');
    const resourceId = monitorUrl ? await monitorProgress(monitorUrl) : null;

    if (resourceId) {
        const newDriverDetails = {
            ...driverDetails,
            fileId: resourceId,
        };
        copyResultShareLink = await getShareLinkById(resourceId);
        if (copyResultShareLink) {
            copyResultShareLink = await addNavParam(copyResultShareLink, newDriverDetails);
        }
    }

    return copyResultShareLink;
}

async function getShareLinkById(fileId: string): Promise<string> {
    const requestUrl = `${GRAPH_COPY_DRIVE_ITEM_BASE}/${fileId}/invite`;
    const requestInit: RequestInit = {
        method: 'POST',
    };
    const response = await OwaFluidOneDriveService(requestUrl, requestInit, {
        prefer: 'getDefaultLink',
    });
    if (response) {
        const driveItems = await response.json();
        if (driveItems?.value?.length > 0) {
            return driveItems.value[0].link?.webUrl;
        }
    }
    return null;
}

async function addNavParam(newUrl: string, locator: OdspFluidDataStoreLocator): Promise<string> {
    const navParam = encodeOdspFluidDataStoreLocator(locator);
    if (!!navParam) {
        const separator = newUrl.indexOf('?') < 0 ? '?' : '&';
        newUrl = `${newUrl}${separator}nav=${navParam}`;
    }
    return newUrl;
}
